module.exports = __webpack_public_path__ + "img/sec13mob.1d6947a0.png";